import React from "react";
import Avaluos_Form from "../components/avaluos/avaluos_form";
import Avaluos_Map from "../components/avaluos/avaluos_map";

const AvaluosPage = () => {
  return (
    <div>
      <h2>Pagina en Construcción</h2>
      <Avaluos_Form />
      <Avaluos_Map />
    </div>
  );
};

export default AvaluosPage;
